import { render, staticRenderFns } from "./uploadLicense.vue?vue&type=template&id=29cbc8d5&"
import script from "./uploadLicense.vue?vue&type=script&lang=js&"
export * from "./uploadLicense.vue?vue&type=script&lang=js&"
import style0 from "./uploadLicense.vue?vue&type=style&index=0&id=29cbc8d5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports